import React from 'react';
import { useFormState } from 'react-final-form';

import { inputFirstNameConfig, inputLastNameConfig } from '../../../configs';
import { InputsLabel } from '../../../libs/enums';
import { CheckboxComponent, TextInputComponent } from '../../dsfr';

export const PersonGroup = React.memo(() => {
  const { values: formValues } = useFormState();

  return (
    <fieldset className="fr-fieldset fr-mb-2w">
      <legend className="fr-sr-only">Demande de nom et prénom</legend>
      <div className="fr-fieldset__element fr-mb-3w">
        <TextInputComponent
          {...inputLastNameConfig}
          autoComplete="family-name"
          className="fr-mb-2w"
          disabled={formValues.lastNameDisabled}
          required={!formValues.lastNameDisabled}
          spellCheck="false"
        />
        <CheckboxComponent label={InputsLabel.LASTNAME_DISABLED} name="lastNameDisabled" />
      </div>
      <div className="fr-fieldset__element">
        <TextInputComponent
          {...inputFirstNameConfig}
          autoComplete="given-name"
          className="fr-mb-2w"
          disabled={formValues.firstNameDisabled}
          required={!formValues.firstNameDisabled}
          spellCheck="false"
        />
        <CheckboxComponent label={InputsLabel.FIRSTNAME_DISABLED} name="firstNameDisabled" />
      </div>
    </fieldset>
  );
});

PersonGroup.displayName = 'PersonGroup';
